/* eslint-disable no-template-curly-in-string */
export const ACCOUNT_EMAIL_INPUT_LABEL = "Email";
export const ACCOUNT_EMAIL_INPUT_PLACEHOLDER = "Enter Email Here";
export const ACCOUNT_FIRST_NAME_INPUT_LABEL = "First Name";
export const ACCOUNT_FIRST_NAME_INPUT_PLACEHOLDER = "Enter First Name Here";
export const ACCOUNT_INFO = "Account Info";
export const ACCOUNT_LAST_NAME_INPUT_LABEL = "Last Name";
export const ACCOUNT_LAST_NAME_INPUT_PLACEHOLDER = "Enter Last Name Here";
export const ACCOUNT_PASSWORD_INPUT_LABEL = "Password";
export const ACCOUNT_PHONE_INPUT_LABEL = "Phone";
export const ACCOUNT_UPDATE_BUTTON_TEXT = "Update";
export const ADD_CARD_BUTTON_TEXT = "Add Card";
export const CANCEL_BUTTON_TEXT = "No";
export const CARD_DELETED_MESSAGE = "Card Deleted";
export const CARD_ON_FILE_TEXT = "Cards On File";
export const CHOOSE_RESTAURANT_LOCATION_TO_ADD_CARD_TEXT = "Choose a location";
export const CONFIRM_BUTTON_TEXT = "Yes";
export const CURRENT_STATUS = "Current Status";
export const DELETE_CARD_BUTTON_TEXT = "Delete";
export const DELETE_CARD_CONFIRM_MESSAGE =
  "Are you sure you want to delete this card";
export const EMPTY_MESSAGE = "You have no previous orders";
export const ERROR_HEADER = "Uh-oh";
export const ERROR_MESSAGE = "An error occurred";
export const INFORMATION_UPDATED_MESSAGE = "Information Updated";
export const LOGOUT_BUTTON_TEXT = "Logout";
export const LOYALTY_AVAILABLE_LOYALTY = "Rewards Balance: $";
export const LOYALTY_EARN_ONE_POINT = "Earn 1 point for every $1 you spend!";
export const LOYALTY_NEXT_TIER =
  "Spend ${threshold} in the next year to unlock the {name} Tier";
export const LOYALTY_NO_REWARDS = "You currently have no rewards";
export const LOYALTY_ONCE_YOU_HIT_100 = "";
export const LOYALTY_TIER_SYSTEM_RULES = "";
export const LOYALTY_UNTIL_YOUR_NEXT_REWARD = " points until your next reward";
export const LOYALTY_LIFETIME_POINTS = "{lifetimePoints} Points";
export const MAKE_PRIMARY_BUTTON_TEXT = "Make Primary";
export const MOBILE_APP_DOWNLOAD = "Download the App and Earn on the Go!";
export const NO_CARDS = "No Cards On File";
export const ORDER_HISTORY = "YOUR ORDER HISTORY";
export const PASSWORD_UPDATED_MESSAGE = "Password Updated";
export const PHONE_NUMBER_UPDATED_MESSAGE = "Phone Number Updated";
export const PRIMARY_CARD_UPDATED = "Primary Card Updated";
export const PRIMARY_SELECTION_TEXT = "Primary";
export const PROFILE_ERROR_MESSAGE =
  "Sorry about this but an error occurred.\nWe've been notified and are working on a fix.";
export const REORDER_BUTTON_TEXT = "Reorder";
export const SET_AS_PRIMARY_PAYMENT =
  "Set this as your primary payment method?";
export const SUCCESS_HEADER = "Complete";
export const UNTIL_YOUR_NEXT_REWARD = "Until your next reward";
export const USER_WELCOME_TEXT = "Welcome, {firstName}!";
export const VIEW_RECEIPT_BUTTON_TEXT = "View Receipt";
export const YOUR_REWARDS = "Your Rewards";
export const YOUR_WALLET = "Your Wallet";

export default {
  ACCOUNT_EMAIL_INPUT_LABEL,
  ACCOUNT_EMAIL_INPUT_PLACEHOLDER,
  ACCOUNT_FIRST_NAME_INPUT_LABEL,
  ACCOUNT_FIRST_NAME_INPUT_PLACEHOLDER,
  ACCOUNT_INFO,
  ACCOUNT_LAST_NAME_INPUT_LABEL,
  ACCOUNT_LAST_NAME_INPUT_PLACEHOLDER,
  ACCOUNT_PASSWORD_INPUT_LABEL,
  ACCOUNT_PHONE_INPUT_LABEL,
  ACCOUNT_UPDATE_BUTTON_TEXT,
  ADD_CARD_BUTTON_TEXT,
  CANCEL_BUTTON_TEXT,
  CARD_DELETED_MESSAGE,
  CARD_ON_FILE_TEXT,
  CHOOSE_RESTAURANT_LOCATION_TO_ADD_CARD_TEXT,
  CONFIRM_BUTTON_TEXT,
  CURRENT_STATUS,
  DELETE_CARD_BUTTON_TEXT,
  DELETE_CARD_CONFIRM_MESSAGE,
  EMPTY_MESSAGE,
  ERROR_HEADER,
  ERROR_MESSAGE,
  INFORMATION_UPDATED_MESSAGE,
  LOGOUT_BUTTON_TEXT,
  LOYALTY_AVAILABLE_LOYALTY,
  LOYALTY_EARN_ONE_POINT,
  LOYALTY_LIFETIME_POINTS,
  LOYALTY_NEXT_TIER,
  LOYALTY_NO_REWARDS,
  LOYALTY_ONCE_YOU_HIT_100,
  LOYALTY_TIER_SYSTEM_RULES,
  LOYALTY_UNTIL_YOUR_NEXT_REWARD,
  MAKE_PRIMARY_BUTTON_TEXT,
  MOBILE_APP_DOWNLOAD,
  NO_CARDS,
  ORDER_HISTORY,
  PASSWORD_UPDATED_MESSAGE,
  PHONE_NUMBER_UPDATED_MESSAGE,
  PRIMARY_CARD_UPDATED,
  PRIMARY_SELECTION_TEXT,
  PROFILE_ERROR_MESSAGE,
  REORDER_BUTTON_TEXT,
  SET_AS_PRIMARY_PAYMENT,
  SUCCESS_HEADER,
  UNTIL_YOUR_NEXT_REWARD,
  USER_WELCOME_TEXT,
  VIEW_RECEIPT_BUTTON_TEXT,
  YOUR_REWARDS,
  YOUR_WALLET,
};
